/* ==========================================================================
   NEUROGENA — globalus „Add to cart" mygtuko uzrasas
   --------------------------------------------------------------------------
   Prideda piktograma, uzrasa „Add items to cart", kaina ir garantijos eilute
   PAGRINDINIAM produkto formos mygtukui visuose produktu puslapiuose.

   Neliecia: greito pridejimo kolekcijose („Choose options"), krepselio
   stalciaus upsell'u ir sekciju mygtuku su savo tekstu.

   Mygtuko NEPERIMA — nededa niekur nieko i krepseli. Visa pirkimo logika
   lieka temos rankose; cia tik uzrasas.

   Isvaizda: assets/nrg-buttons.css
   ========================================================================== */
(function () {
  var TXT = 'Add items to cart';
  var SUB = 'No results? Full refund. No questions';
  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M6 6h15l-1.5 9h-12L6 6zM6 6L5 3H2" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<circle cx="9" cy="20" r="1.4" fill="#fff"/><circle cx="18" cy="20" r="1.4" fill="#fff"/></svg>';

  /* --- mygtukas ---------------------------------------------------------- */
  function mainBtn() {
    var b =
      document.querySelector('.main-product-form .product-form__buttons .product-form__submit') ||
      document.querySelector('product-form[data-main="true"] .product-form__submit');
    if (!b || b.closest('cart-drawer')) return null;
    return b;
  }

  /* --- kainos skaitymas --------------------------------------------------- */
  function clean(t) {
    return (t || '').replace(/\bOnly\b/gi, '').replace(/[!•]/g, '').replace(/\s+/g, ' ').trim();
  }
  function parseNum(txt) {
    var m = (txt || '').match(/[0-9][0-9.,\s ]*[0-9]|[0-9]/);
    if (!m) return null;
    var ns = m[0].replace(/[\s ]/g, '');
    var lc = ns.lastIndexOf(','), ld = ns.lastIndexOf('.'), ls = Math.max(lc, ld);
    if (ls > -1 && ns.length - ls - 1 > 0 && ns.length - ls - 1 <= 2)
      return parseFloat(ns.slice(0, ls).replace(/[.,]/g, '') + '.' + ns.slice(ls + 1));
    return parseFloat(ns.replace(/[.,]/g, ''));
  }
  /* Perrasant kaina isaugomas TAS PATS formatas (€51,75 vs $51.75) */
  function formatLike(txt, n) {
    var m = (txt || '').match(/[0-9][0-9.,\s ]*[0-9]|[0-9]/);
    if (!m) return String(n);
    var ns = m[0], idx = txt.indexOf(ns), pre = txt.slice(0, idx), suf = txt.slice(idx + ns.length);
    var lc = ns.lastIndexOf(','), ld = ns.lastIndexOf('.'), ls = Math.max(lc, ld), dec = 0, ds = '', ts = '';
    if (ls > -1 && ns.length - ls - 1 > 0 && ns.length - ls - 1 <= 2) {
      ds = ns.charAt(ls); dec = ns.length - ls - 1; ts = ds === ',' ? '.' : ',';
    } else { ts = lc > -1 ? ',' : ld > -1 ? '.' : ''; }
    var f = n.toFixed(dec), pp = f.split('.'), ip = pp[0], dp = pp[1] || '';
    ip = ip.replace(/\B(?=(\d{3})+(?!\d))/g, ts || '');
    return pre + ip + (dec > 0 ? ds + dp : '') + suf;
  }

  /* Pasiulymo valdikliai, kuriuose kaina JAU galutine (kiekiu dauginti nereikia):
     temos kiekio pakopos ir musu „pill" korteles. */
  function hasBundle() {
    return !!document.querySelector('quantity-breaks, .custom-pills-container');
  }

  /* Pill'ai: pazymetas radio guli .custom-pills-cell viduje, kaina — .pill-price-new */
  function pillPrice() {
    var chk = document.querySelector('.custom-pills-container input[type="radio"]:checked');
    if (!chk) return null;
    var cell = chk.closest('.custom-pills-cell') || chk.parentElement;
    var p = cell ? cell.querySelector('.pill-price-new') : null;
    return p && p.textContent.trim() ? clean(p.textContent) : null;
  }

  /* Kiekio pakopu valdiklis pats yra kiekio mechanizmas — jo kaina jau galutine */
  function bundlePrice() {
    var qb = document.querySelector('quantity-breaks');
    if (!qb) return null;
    var chk = qb.querySelector('input:checked'), lab = null;
    if (chk) {
      lab = chk.id ? qb.querySelector('label[for="' + chk.id + '"]') : null;
      if (!lab) lab = chk.nextElementSibling;
    }
    var p = lab && lab.querySelector ? lab.querySelector('.quantity-break__price') : null;
    return p && p.textContent.trim() ? clean(p.textContent) : null;
  }

  function productPrice() {
    var el = document.querySelector(
      '.product__info-container .price__sale .price-item--sale,' +
      '.product__info-container .price__regular .price-item--regular,' +
      '.product__info-container .price-item--regular,' +
      '.price__container .price-item--regular'
    );
    return el ? clean(el.textContent) : null;
  }

  function addonAmount() {
    var w = document.querySelector('.patchad-wrap');
    if (!w) return 0;
    var card = w.querySelector('#patchAddonCard') || w.querySelector('.patchad');
    if (!card || !card.classList.contains('is-on')) return 0;
    var now = w.querySelector('.patchad-now');
    var v = now ? parseNum(now.textContent) : null;
    if (v == null) v = parseFloat(w.getAttribute('data-pricenum')) || 0;
    return v || 0;
  }

  function qty() {
    var i = document.querySelector(
      '.main-product-form input[name="quantity"], .product__info-container input[name="quantity"]'
    );
    var n = i ? parseInt(i.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* Isjungtas mygtukas reiskia DU skirtingus dalykus:
       a) prekes nera;
       b) tema siuo metu krauna pasirinkta varianta.
     Anksciau abu buvo laikomi (a), todel kraunant varianta turinys buvo
     isimamas ir mygtukas ~350 ms atrode persikraunantis.

     Pagal etikete atskirti negalima — si tema net isparduotam variantui palieka
     „+ Add to cart". Variantu JSON puslapyje irgi nera, todel prieinamumas
     imamas is /products/<handle>.js (vienas uzklausimas, po to is atminties). */
  var VARIANTS = null, kraunama = false;
  function loadVariants() {
    if (VARIANTS || kraunama) return;
    var h = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!h) return;
    kraunama = true;
    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.variants) {
          VARIANTS = {};
          d.variants.forEach(function (v) { VARIANTS[String(v.id)] = v.available; });
          apply();
        }
      })
      .catch(function () {})
      .then(function () { kraunama = false; });
  }

  function soldOut(b) {
    if (!b.disabled) return false;
    if (!VARIANTS) { loadVariants(); return false; }  /* kol nezinom — nieko nekeiciam */
    var ids = Object.keys(VARIANTS);
    if (ids.length === 1) return VARIANTS[ids[0]] === false;   /* vieno varianto preke */
    /* Varianto ID imamas is TOS formos, kuriai priklauso mygtukas: puslapyje yra
       ir kitu /cart/add formu (krepselio stalciaus upsell'ai), o ju ID kitoks. */
    var form = b.closest('form');
    var i = form ? form.querySelector('input[name="id"]') : null;
    var id = i ? String(i.value) : null;
    return !!id && VARIANTS[id] === false;
  }

  /* --- pritaikymas -------------------------------------------------------- */
  /* apply() privalo buti IDEMPOTENTISKAS: jei niekas nepasikeite, jis neturi
     liesti DOM. Kitaip stebetojas (zemiau) pats save uzkurtu be galo. */
  var busy = false;
  function apply() {
    if (busy) return;
    busy = true;
    try { run(); } finally { busy = false; }
  }

  function run() {
    var b = mainBtn();
    if (!b) return;

    /* Isparduota — paliekamas temos uzrasas. Kraunant varianta turinys NELIECIAMAS. */
    if (soldOut(b)) {
      var old = b.querySelector('.nrg-atc__in');
      if (old) old.remove();
      b.classList.remove('nrg-atc-on');
      if (!b.classList.contains('nrg-sold-out')) b.classList.add('nrg-sold-out');
      return;
    }
    if (b.classList.contains('nrg-sold-out')) b.classList.remove('nrg-sold-out');

    b.classList.add('nrg-atc-on');

    /* Sekcijos bloko apvalkalas — atsarga narsyklems be :has() palaikymo.
       Stiliai galioja tik ten, kur ikeltas pirkimo blokas. */
    var pf = b.closest('product-form');
    var blokas = pf ? pf.parentElement : null;
    if (blokas && blokas.parentElement &&
        blokas.parentElement.classList.contains('product__info-container') &&
        !blokas.classList.contains('nbb-atc-wrap')) {
      blokas.classList.add('nbb-atc-wrap');
    }

    var w = b.querySelector('.nrg-atc__in');
    if (!w) {
      w = document.createElement('span');
      w.className = 'nrg-atc__in';
      w.innerHTML =
        '<span class="nrg-atc__row">' + ICON + '<span class="nrg-atc__t">' + TXT + '</span>' +
        '<span class="nrg-atc__p"></span></span>' +
        '<small class="nrg-atc__s">' + SUB + '</small>';
      b.appendChild(w);
    }

    var base = bundlePrice() || pillPrice() || productPrice();
    var n = parseNum(base);
    var out = base;
    if (n != null) {
      var total = hasBundle() ? n : n * qty();
      total += addonAmount();
      if (total !== n) out = formatLike(base, total);
    }
    var pe = b.querySelector('.nrg-atc__p');
    var txt = out || '';
    if (pe && pe.textContent !== txt) pe.textContent = txt;
  }

  /* --- paleidimas --------------------------------------------------------- */
  /* Mygtukas gali dar neegzistuoti (skriptas galvoje), todel gaudom ji kas kadra. */
  var frames = 0;
  (function boot() {
    apply();
    if (++frames < 120 && !document.querySelector('.nrg-atc__in')) requestAnimationFrame(boot);
  })();

  document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('load', start);

  /* Pasirinkus varianta tema perpiesia formos sekcija ir isvalo mygtuko turini.
     Stebetojas ji atstato dar PRIES piesima (MutationObserver iskvieciamas
     mikrouzduociu taske), todel vartotojas mato tik pasikeitusia kaina.

     Stebeti reikia <html>, o ne .product__info-container: dalis sablonu
     (pvz. neurogena-max) pakeicia pati konteineri, ir stebetojas liktu kabeti
     ant atjungto mazgo — butent del to mygtukas buvo tuscias ~350 ms. */
  var obs = new MutationObserver(apply);
  function start() {
    loadVariants();
    apply();
    obs.disconnect();
    obs.observe(document.documentElement, {
      childList: true, subtree: true, characterData: true
    });
  }
  start();

  document.addEventListener('change', apply, true);
  document.addEventListener('click', apply, true);
  document.addEventListener('shopify:section:load', start);
  setInterval(apply, 2000);   /* atsarginis tinklas, jei kas nors praslystu */
})();
